import { render, staticRenderFns } from "./Authd.vue?vue&type=template&id=fda112b6&"
import script from "./Authd.vue?vue&type=script&lang=js&"
export * from "./Authd.vue?vue&type=script&lang=js&"
import style0 from "./Authd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports